export default [
    {
        path: '/logoutTip', // 注销
        component: resolve => require(['@/pages/user/logoutTip'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/logoutSend', // 注销
        component: resolve => require(['@/pages/user/logoutSend'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/testzbd', // ceshi
        component: resolve => require(['@/pages/user/testzbd'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/mobileVer', // 小程序无痕验证码
        component: resolve => require(['@/pages/user/mobileVer'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/appVer', // app无痕验证码
        component: resolve => require(['@/pages/user/appVer'], resolve),
        meta: { title: "长龙航空" }
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/user.js